import { VRow, VCol} from 'vuetify/lib'
import {formattingNumber} from '@/libs/util';
import styles from './../style.module.less'
export default {
    props: {
        fields: {
            type: Array
        },
        value: {
            type: Object
        },
        title: {
            type: String
        }
    },
    methods: {
        display({field, value}) {
            if (field.render) {
             return field.render({
                    field,
                    value
                }) 
            }
            let res = null
            if ([undefined, null, ''].includes(this.value[field.value])) {
                return '-'
            }
            switch (field.type) {
                case 'money_field':
                    res = formattingNumber(this.value[field.value], 2)
                    
                    break;
                default:
                
                    res = this.value[field.value]
                    break;
            }
            return res
        }
    },
    render() {
        return <div >
            {!!this.title && <p style="font-weight:bold">{this.title}</p>}
            <VRow class={styles['row']}>
                {this.fields.map(field => {
                    return <VCol cols={field.span || 4} >
                        {!!field.renderT && <div>{field.renderT({field, value:this.value})}</div>}
                       {!field.renderT && <div style="display:flex">
                           <div style="flex:1;text-align:left">{field.text}:</div>
                           <div style="flex:1;text-align:right">{this.display({field, value: this.value})}</div>
                       </div> }
                    </VCol>
                })}
            </VRow>
        </div>
    }
}